(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.upScrollDistance = 0;   // px acumulados scrolleando hacia arriba
      this.revealed = false;       // header visible en sticky
      this.revealedAt = 0;         // posición al revelar
      this.lockedAfterHide = false; // bloqueado hasta próximo scroll hacia abajo

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // Cuántos px hay que scrollear hacia arriba para que aparezca el header
      const REVEAL_THRESHOLD = 40;
      // Cuántos px scrolleado arriba desde que se reveló para volver a ocultarlo
      const HIDE_AGAIN_THRESHOLD = Math.round(window.innerHeight * 0.4);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // ── Scrolleando hacia ABAJO ──
        this.header.classList.add('scrolled-past-header');
        this.upScrollDistance = 0;
        this.revealed = false;
        this.lockedAfterHide = false; // al bajar se desbloquea para el próximo upscroll
        if (this.preventHide) {
          this.currentScrollTop = scrollTop;
          return;
        }
        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // ── Scrolleando hacia ARRIBA ──
        this.header.classList.add('scrolled-past-header');

        if (this.lockedAfterHide) {
          // Oculto tras threshold — no revelar hasta que el usuario baje
          this.currentScrollTop = scrollTop;
          return;
        }

        this.upScrollDistance += this.currentScrollTop - scrollTop;

        if (!this.preventReveal) {
          if (!this.revealed) {
            if (this.upScrollDistance >= REVEAL_THRESHOLD) {
              this.revealed = true;
              this.revealedAt = scrollTop;
              requestAnimationFrame(this.reveal.bind(this));
            }
          } else {
            // Visible — ocultar si scrolleó suficiente desde que apareció
            if (this.revealedAt - scrollTop >= HIDE_AGAIN_THRESHOLD) {
              this.revealed = false;
              this.upScrollDistance = 0;
              this.lockedAfterHide = true; // bloquear hasta próximo downscroll
              requestAnimationFrame(this.hide.bind(this));
            }
          }
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }

      } else if (scrollTop <= this.headerBounds.top) {
        // ── Llegó al top ──
        this.header.classList.remove('scrolled-past-header');
        this.upScrollDistance = 0;
        this.revealed = false;
        this.lockedAfterHide = false;
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
